import { canonicalBytes } from "./canonical.js";
import { concatBytes, utf8 } from "./encoding.js";
import { signBytes } from "./crypto.js";
export function humanClientRequestSigningPayload(input) {
    return concatBytes(utf8("vox.human.client.signature.v1"), new Uint8Array([0]), canonicalBytes({ method: input.method, path: input.path, principal_id: input.principal_id, issued_at: input.issued_at }));
}
export function signHumanClientRequest(input, secretKey) {
    return signBytes(humanClientRequestSigningPayload(input), secretKey);
}
//# sourceMappingURL=human-auth.js.map